import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import hero_bg from "../../assets/hero_bg.svg";
import hero_bg_mobile from "../../assets/hero_bg_mobile.svg";
import footer_blob_mobile from "../../assets/footer_blob_mobile.svg";

//Components
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";

//Local Components
import Hero from "./Hero";
import Faq from "./Faq";
import HeroAnimation from "./HeroAnimation";

import { MOBILE } from "../../constants/breakpoints";

function Home() {
  return (
    <>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          min-height: 100vh;
          background-repeat: no-repeat;
          background-position: top right;
          position: relative;
          z-index: 100;
        `}
      >
        <img
          css={css`
            display: flex;
            width: 100%;
            position: absolute;
            top: 0;
            right: 0;
            @media (min-width: ${MOBILE+1}px) {
              display: none;
            }
          `}
          src={hero_bg_mobile}
          alt=""
        />
        <HeroAnimation />
        <Nav />
        <Hero />
        <Faq />
      </div>
      <span
        css={css`
          position: relative;
        `}
      >
        {/* mobile footer blob background */}
        <img
          css={css`
            width: 100%;
            position: absolute;
            top: -50%;
            display: none;
            @media (max-width: 375px) {
              display: block;
            }
            @media (max-width: 375px) {
              top: -40%;
            }
          `}
          src={footer_blob_mobile}
          alt=""
        />
        <Footer />
      </span>
    </>
  );
}

export default Home;
